export default __webpack_public_path__ + "static/media/location_grey.e51d3106.svg";